module.exports = __webpack_public_path__ + "static/react-themes-stellar-3c01558246fb6624697f234f7f2aa36b.jpg";